var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './TooltipContent.module.css';
export var TooltipContent = function () {
    return (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: styles.tooltip_content_paragraph }, { children: "Take a photo of your document." })), _jsx("p", __assign({ className: styles.tooltip_content_paragraph }, { children: "The photo should be:" })), _jsxs("ul", __assign({ className: styles.tooltip_content_list }, { children: [_jsx("li", __assign({ className: styles.tooltip_content_item }, { children: "bright and clear" })), _jsx("li", __assign({ className: styles.tooltip_content_item }, { children: "all corners of the documents should be visible" }))] }))] }));
};
export var WarningTooltipContent = function () {
    return (_jsx("div", { children: "If you want to change the document type please delete previously uploaded images." }));
};
